<div *ngIf="showPopup" class="cookie-consent">
  This website uses cookies to provide you with a great user experience. By using it, you accept our <a
  style="color: #FFFFFF" [href]="constantService.configuration.privacyPolicyUrl" target="_blank">Privacy Policy</a>.
  <div class="d-flex w-100 justify-content-evenly" [class.flex-column]="mobileSizeService.isMobileSize" style="gap: 16px;">
    <div class="cookie-consent-btn w-100" (click)="onOk()">Ok</div>
    <div class="cookie-consent-btn w-100" (click)="onNope()">Setup minimum</div>
  </div>
</div>
